import { AfterViewInit, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { TipoContato } from '@core/models/entidade';
import { UFService } from '@core/services/uf.service';
import { PaisService } from '@core/services/pais.service';
import { TipoContatoService } from '@core/services/tipocontato.service';
import { RouteAction } from '@core/action/action';
import { ActivatedRoute } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { CEPService } from '@core/services/cep.service';
import { MessageService } from '@core/services/message.service';
import { CidadeService } from '@core/services/cidade.service';

@Component({
  selector: 'app-contato-modal',
  templateUrl: './contato-modal.component.html',
  styleUrls: ['./contato-modal.component.scss']
})
export class ContatoModalComponent implements OnInit {

  @Input() contato: any;
  contatoEditado: any;
  dataSet: any[] = [];
  contatos: any[] = [];

  cep: string = '';
  cidadeList: any[] = [];
  tipoContatoSelecionada: any;
  tipoContatoList: any[] = [];
  paisesList: any[] = [];
  ufList: any[] = [];
  searchControl = new FormControl();
  acao!: RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  defaultPais: any;
  contatoForm!: FormGroup;

  isVisible = false;

  constructor(
    private fb: FormBuilder,
    private ufService: UFService,
    private paisService: PaisService,
    private tipoContatoService: TipoContatoService,
    private route: ActivatedRoute,
    private modalRef: NzModalRef,
    private cepService: CEPService,
    private messageService: MessageService,
    private cidadeService: CidadeService

  ) { this.contatoEditado = { ...this.contato }; }

  ngAfterViewInit(): void {


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.contato) {
      this.contatoForm.patchValue(this.contato);
    }

    this.checkAcao();
  }

  checkAcao() {
    this.inserir = this.acao == RouteAction.Inserir;
    this.editar = this.acao == RouteAction.Editar;
    this.visualizar = this.acao == RouteAction.Visualizar;
  }

  ngOnInit(): void {
    this.carregarListas();
    this.buildForm();
    this.checkAcao();

    this.enderecoUf?.valueChanges.subscribe((val: any) => {
      // console.log('val', val);
      if (val?.id) {
        // console.log('val.id', val.id);
        this.cidadeService.getCidadesByUf(val.id).subscribe(data => {
          this.cidadeList = data;
        });
      } else this.cidadeList = [];
    })


  }

  carregarListas(): void {
    forkJoin({
      tipoContato: this.tipoContatoService.listar(),
      enderecoUf: this.ufService.listar(),
      pais: this.paisService.listar()

    }).subscribe(({ tipoContato, enderecoUf, pais }) => {
      this.tipoContatoList = tipoContato;
      this.ufList = enderecoUf;
      this.paisesList = pais;
      // if (this.contato && this.contato.tipoContato) {
      //   this.contato.tipoContato = { id: this.contato?.tipoContato };
      this.contatoForm.patchValue(this.contato);
      // }

      const defaultPais = this.acao === RouteAction.Inserir ? this.paisesList.find(pais => pais.nome === 'Brasil') : null;
      // console.log('defaultPais:', defaultPais);

      // Se defaultPais foi encontrado, defina-o no formulário
      if (defaultPais) {
        this.contatoForm.patchValue({
          pais: defaultPais
        });
      }
    });
  }

  buildForm(): void {
    this.contatoForm = this.fb.group({
      id:[''],
      pais: ['', Validators.required],
      enderecoUf: ['', Validators.required],
      enderecoMunicipio: ['', Validators.required],
      enderecoBairro: ['', Validators.required],
      enderecoCep: ['', Validators.required],
      enderecoNumero: [''],
      enderecoLogradouro: ['', Validators.required],
      enderecoComplemento: [''],
      informacoesAdicionais: ['', Validators.required],
      ddi: [''],
      telefone: [''],
      telefoneAdicional: [''],
      ddiFax: [''],
      fax: [''],
      faxAdicional: [''],
      email: ['', [Validators.email, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')]],
      siteUrl: ['', Validators.required],
      ramal: [''],
      tipoContato: ['', Validators.required],
      flagPrincipal: [false]
    });
  }

  checkIfPrincipal(event: MouseEvent): void {
    const inputElement = event.target as HTMLInputElement;

    if (!inputElement || inputElement.checked == null) {
      return;
    }

    const alreadyPrincipal = this.contatos.some(contato =>
      contato.flagPrincipal && contato !== this.contatoEditado
    );

    if (alreadyPrincipal && !this.contatoEditado.flagPrincipal) {
      this.messageService.warning('Já existe um contato marcado como principal. Não é possível marcar outro.');
      inputElement.checked = false;
    } else {
      // console.log('Checkbox is checked:', inputElement.checked);
      this.contatoEditado.flagPrincipal = inputElement.checked;
    }
  }


  onTipoContatoChange(value: any): void {
    if (value !== undefined) {
      this.tipoContatoSelecionada = this.tipoContatoList.find((tipo: any) => tipo.id === value);
      this.updateFormFields();
    }
  }

  updateFormFields(): void {
    this.contatoForm.removeControl('email');
    this.contatoForm.removeControl('telefone');

    if (this.tipoContatoSelecionada?.nomeTipoEntidade === TipoContato.Email) {
      this.contatoForm.addControl('email', this.fb.control('', [Validators.required, Validators.email, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')]));

    } else {
      this.contatoForm.addControl('email', this.fb.control(''));
    }

    if (this.tipoContatoSelecionada?.nomeTipoEntidade === TipoContato.Telefone) {
      this.contatoForm.addControl('telefone', this.fb.control('', Validators.required));
    } else {
      this.contatoForm.addControl('telefone', this.fb.control(''));
    }
    this.setFormState();
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    } if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    } else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    } else if (a?.id !== undefined && b !== undefined) {
      return a.id === b;
    } else if (a !== undefined && b?.id !== undefined) {
      return a === b?.id;
    } else if (a?.uf !== undefined && b?.sigla !== undefined) {
      // console.log('a.uf', a.uf);
      return a?.uf === b?.sigla
    } else if (a?.cidade !== undefined && b?.nome !== undefined) {
      // console.log('a.cidade', a.cidade);
      // console.log('b.nome', b.nome);
      return a?.cidade === b?.nome && a?.uf === b?.uf.sigla
    } else {
      return a === b;
    }
  }

  setFormState(): void {
    if (this.visualizar) {
      this.contatoForm.disable();
    }
  }

  handleOk(): void {
    const flagPrincipal = this.contatoForm.get('flagPrincipal')?.value;
    if (flagPrincipal && this.dataSet.some(contact => contact.flagPrincipal
      && contact.id !== this.contatoForm.get('id')?.value)) {
      alert('Já existe um contato principal.');
    } else {
      this.isVisible = false;
      let objEnvio = { ...this.contatoForm.getRawValue() };
      this.modalRef.close(objEnvio);
    }
  }

  handleCancel(): void {
    this.isVisible = false;
    this.modalRef.close();

  }

  onCepBlur(): void {
    const cep = this.contatoForm.get('enderecoCep')?.value;
    if (cep) {
      this.fetchCepData(cep);
    }
  }

  fetchCepData(cep: string): void {
    this.cepService.buscarEndereco(cep).subscribe(
      (data: any) => {
        if (!data.erro) {
          // console.log('CEP encontrado', data);

          // Encontrar a UF correspondente na lista de UFs
          const ufSelecionada = this.ufList.find(uf => uf.sigla === data.uf);
           // console.log('ufSelecionada', ufSelecionada);
          if (ufSelecionada && (!this.enderecoUf?.value || this.enderecoUf?.value.id !== ufSelecionada.id)) {
            this.enderecoUf?.patchValue(ufSelecionada); // Atualiza o valor do select de UF
            this.cidadeService.getCidadesByUf(ufSelecionada.id).subscribe(cidades => {
              this.cidadeList = cidades;
              this.setMunicipio(data); // Chamada para configurar a cidade após a atualização
            });
          } else {
            this.setMunicipio(data); // Caso a UF já esteja selecionada
          }

          this.contatoForm.patchValue({
            enderecoLogradouro: data.logradouro,
            enderecoBairro: data.bairro,
          });
        } else {
          console.error('CEP não encontrado');
        }
      },
      (error) => {
        console.error('Erro ao buscar o CEP', error);
      }
    );
  }

  setMunicipio(data: any): void {
    const municipioSelecionado = this.cidadeList.find(cidade =>
      cidade.nome === data.cidade && cidade.uf.sigla === data.uf
    );

    this.contatoForm.patchValue({
      enderecoMunicipio: municipioSelecionado || null,
      enderecoUf: municipioSelecionado?.uf || null,
    });
  }




  get enderecoUf() {
    return this.contatoForm.get('enderecoUf');
  }

}
